import type { ReactNode } from "react";

import { useAuth } from "@/features/auth/hooks";
import type { UserRole } from "@/lib/user";
import { arrayRegExpCheck } from "@/lib/utils";

interface RoleConditionProps {
  roles: UserRole[];
  fallback?: React.ReactNode | null;
  children: ReactNode;
}

export function RoleCondition({
  children,
  roles,
  fallback = null,
}: RoleConditionProps) {
  const { user } = useAuth();

  const role = user?.profile.default_role;

  if (arrayRegExpCheck(roles, role)) {
    return <>{children}</>;
  }

  return fallback;
}
